import React from "react";
import Modal from "react-modal";

const VideoModal = ({
  isOpen,
  onClose,
  videoUrl,
  muted = true,
  autoPlay = true,
  controls = true,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Media Preview Modal"
      className="media-preview-modal"
      overlayClassName="media-preview-modal-overlay"
    >
      <div className="modal-content">
        <video
          src={videoUrl}
          autoPlay={autoPlay}
          muted={muted}
          preload="auto"
          className="media-preview-element"
          controls={controls}
        />
        <button onClick={onClose} className="modal-close-button">
          <img
            alt="Close Modal"
            src="/images/simpleCrossWhite.svg"
            className="media-preview-close-icon"
          />
        </button>
      </div>
    </Modal>
  );
};

export default VideoModal;
